import { useCallback, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import * as i18n from "util/i18n";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import { savebase64AsPDF } from "util/downloadMobile";
import { actions as notificationActions } from "reducers/notification";
import { useDispatch } from "react-redux";

const useReactPrint = (title, id, notificationPage) => {
    const dispatch = useDispatch();
    const componentRef = useRef(null);
    const mobileRef = useRef(null);
    const reactToPrintContent = useCallback(() => componentRef.current, [componentRef.current]);
    const [mobileIsLoading, setMobileIsLoading] = useState(false);

    const handlePrintDesktop = useReactToPrint({
        copyStyles: true,
        content: reactToPrintContent,
        documentTitle: `${i18n.get(title, title)}${id ? ` - ${id}` : ""}`,
        removeAfterPrint: true,
        onBeforeGetContent: () => {
            const content = componentRef.current;
            if (content) {
                content.style.width = "100%";
            }
        },
    });

    const generateImage = async (element) => {
        const dataUrl = await toPng(element, { backgroundColor: "#FFFFFF" });
        return dataUrl;
    };

    const handlePrintMobile = async () => {
        setMobileIsLoading(true);
        try {
            const element = mobileRef.current;
            const image = await generateImage(element);
            const width = element?.offsetWidth + 320;
            const height = element?.scrollHeight + 1200;

            const doc = new jsPDF("p", "px", [width, height]);
            doc.addImage(image, "png", width / 12, 50);
            const out = doc.output();

            const filename = `${i18n.get(title, title)}${id ? ` - ${id}` : ""}.pdf`;
            const contentType = "application/pdf";

            let folderpath;
            if (window.cordova.platformId === "android") {
                const path = window.cordova.file.externalRootDirectory;
                folderpath = `${path}Download/`;
            }
            if (window.cordova.platformId === "ios") {
                folderpath = window.cordova.file.documentsDirectory;
            }

            savebase64AsPDF(folderpath, filename, btoa(out), contentType);

            if (notificationPage) {
                dispatch(
                    notificationActions.showNotification(i18n.get("download.succes"), "success", [notificationPage]),
                );
            }
        } finally {
            setMobileIsLoading(false);
        }
    };

    const handleShareMobile = async () => {
        try {
            const image = await generateImage(mobileRef.current);
            window.plugins.socialsharing.shareWithOptions({ files: [image] }, null, null);
        } catch (error) {
            // console.error("Image generation error:", error);
        }
    };

    const handlePrint = () => {
        if (!window.cordova) {
            handlePrintDesktop();
        } else {
            handlePrintMobile();
        }
    };

    return { componentRef, handlePrint, handlePrintMobile, handleShareMobile, mobileRef, mobileIsLoading };
};

export default useReactPrint;
